/* Back-in-stock ("notify me") for sold-out sizes. Added for Teo.
   1) Product cards: tapping a crossed-out size opens a popup with an email field.
   2) Product page: the back-in-stock card (snippets/buy-buttons.liquid) submits without leaving the page.
   Both post to the store's normal /contact form, in the same format as the old product-page form
   ("Stok bildirim talebi: <product> | <variant> | Variant ID: <id>"), so requests keep landing in the same inbox. */
(function () {
  if (window.__notifyMeBound) return;
  window.__notifyMeBound = true;

  var isTr = /^tr/i.test(document.documentElement.lang || '');
  var T = isTr ? {
    title: 'Stok gelince haber ver',
    note: 'E-posta adresini bırak, stoğa girer girmez sana haber verelim.',
    placeholder: 'E-posta adresiniz',
    submit: 'Haber ver',
    sending: 'Gönderiliyor…',
    consent: 'Göndererek, bu ürünün stok bildirimi için e-posta almayı kabul edersin.',
    done: 'Tamamdır! Stoğa girince sana e-posta göndereceğiz.',
    close: 'Kapat',
    error: 'Bir sorun oluştu. Lütfen tekrar dene.'
  } : {
    title: 'Notify me',
    note: 'Leave your email and we will let you know the moment it is back.',
    placeholder: 'Your email address',
    submit: 'Notify me',
    sending: 'Sending…',
    consent: 'By submitting, you agree to receive an email about this restock.',
    done: 'You are on the list! We will email you when it is back in stock.',
    close: 'Close',
    error: 'Something went wrong. Please try again.'
  };

  var contactUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'contact';

  function absUrl(u) {
    try { return new URL(u || location.href, location.origin).href; } catch (e) { return u || location.href; }
  }

  function buildBody(product, variant, id) {
    return 'Stok bildirim talebi: ' + product + ' | ' + variant + ' | Variant ID: ' + id;
  }

  /* Posts like the normal contact form does. Resolves true on success. */
  function send(fields) {
    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[email]', fields.email);
    fd.append('contact[Product]', fields.product);
    fd.append('contact[Product URL]', fields.url);
    fd.append('contact[Variant]', fields.variant);
    fd.append('contact[Variant ID]', fields.id);
    fd.append('contact[body]', buildBody(fields.product, fields.variant, fields.id));

    return fetch(contactUrl, { method: 'POST', body: fd, credentials: 'same-origin' }).then(function (res) {
      /* Shopify answers a successful contact post with a redirect to ?contact_posted=true. */
      return res.ok && res.url.indexOf('contact_posted=true') !== -1;
    });
  }

  /* If the background post is refused (e.g. a bot check), fall back to a normal form post so the request still goes
     through the way the theme form always did. */
  function nativeFallback(fields) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = contactUrl;
    f.style.display = 'none';
    var data = {
      form_type: 'contact', utf8: '✓',
      'contact[email]': fields.email, 'contact[Product]': fields.product, 'contact[Product URL]': fields.url,
      'contact[Variant]': fields.variant, 'contact[Variant ID]': fields.id,
      'contact[body]': buildBody(fields.product, fields.variant, fields.id)
    };
    Object.keys(data).forEach(function (k) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = k; i.value = data[k];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  /* ---------- popup (product cards) ---------- */
  var overlay, dialog, form, input, submitBtn, errorEl, successEl, titleEl, productEl, noteEl, current, lastFocus;

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  /* Keeps the overlay exactly the size of the VISIBLE screen area. On phones the on-screen keyboard shrinks the
     visual viewport; without this the card (which floats near the bottom) would end up behind the keyboard. */
  function fitToViewport() {
    if (!overlay) return;
    var vv = window.visualViewport;
    if (!vv) return;
    overlay.style.top = vv.offsetTop + 'px';
    overlay.style.left = vv.offsetLeft + 'px';
    overlay.style.width = vv.width + 'px';
    overlay.style.height = vv.height + 'px';
    overlay.style.bottom = 'auto';
    overlay.style.right = 'auto';
    overlay.classList.toggle('is-keyboard', vv.height < window.innerHeight * 0.8);
  }

  function build() {
    overlay = el('div', 'nm-overlay');
    dialog = el('div', 'nm-dialog');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');

    var close = el('button', 'nm-close');
    close.type = 'button';
    close.setAttribute('aria-label', T.close);
    close.innerHTML = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13"/></svg>';
    close.addEventListener('click', closeModal);

    titleEl = el('h2', 'nm-title', T.title);
    productEl = el('p', 'nm-product');
    noteEl = el('p', 'nm-note', T.note);

    form = el('form', 'nm-form');
    input = el('input', 'nm-input');
    input.type = 'email';
    input.required = true;
    input.name = 'email';
    input.autocomplete = 'email';
    input.inputMode = 'email';
    input.placeholder = T.placeholder;
    input.setAttribute('aria-label', T.placeholder);
    submitBtn = el('button', 'nm-submit', T.submit);
    submitBtn.type = 'submit';
    errorEl = el('p', 'nm-error');
    errorEl.hidden = true;
    errorEl.setAttribute('role', 'alert');
    var consent = el('p', 'nm-consent', T.consent);
    form.appendChild(input);
    form.appendChild(submitBtn);
    form.appendChild(errorEl);
    form.appendChild(consent);
    form.addEventListener('submit', onSubmit);

    successEl = el('div', 'nm-success');
    successEl.hidden = true;
    var ok = el('span', 'nm-success-ok', '✓');
    var okText = el('p', '', T.done);
    var okClose = el('button', 'nm-submit', T.close);
    okClose.type = 'button';
    okClose.addEventListener('click', closeModal);
    successEl.appendChild(ok);
    successEl.appendChild(okText);
    successEl.appendChild(okClose);

    dialog.appendChild(close);
    dialog.appendChild(titleEl);
    dialog.appendChild(productEl);
    dialog.appendChild(noteEl);
    dialog.appendChild(form);
    dialog.appendChild(successEl);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', fitToViewport);
      window.visualViewport.addEventListener('scroll', fitToViewport);
    }
  }

  function openModal(data) {
    if (!overlay) build();
    current = {
      product: data.productTitle || '',
      url: absUrl(data.productUrl),
      variant: data.variantTitle || '',
      id: data.variantId || ''
    };
    productEl.textContent = current.product + ' — ' + current.variant;
    dialog.setAttribute('aria-label', T.title + ': ' + current.product + ' ' + current.variant);
    errorEl.hidden = true;
    successEl.hidden = true;
    form.hidden = false;
    noteEl.hidden = false;
    submitBtn.disabled = false;
    submitBtn.textContent = T.submit;
    input.value = '';
    lastFocus = document.activeElement;
    document.body.classList.add('nm-lock');
    fitToViewport();
    /* short delay (not requestAnimationFrame, which pauses in background tabs) so the open transition plays */
    setTimeout(function () {
      overlay.classList.add('is-open');
      /* On touch screens don't pop the keyboard open by itself: the whole card stays visible until they tap the field. */
      if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) {
        setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 120);
      }
    }, 20);
  }

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('nm-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function onSubmit(e) {
    e.preventDefault();
    if (!form.reportValidity()) return;
    var fields = { email: input.value.trim(), product: current.product, url: current.url, variant: current.variant, id: current.id };
    submitBtn.disabled = true;
    submitBtn.textContent = T.sending;
    errorEl.hidden = true;

    send(fields).then(function (ok) {
      if (ok) {
        form.hidden = true;
        noteEl.hidden = true;
        successEl.hidden = false;
      } else {
        nativeFallback(fields);
      }
    }).catch(function () {
      submitBtn.disabled = false;
      submitBtn.textContent = T.submit;
      errorEl.textContent = T.error;
      errorEl.hidden = false;
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-notify-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    openModal(trigger.dataset);
  });

  /* ---------- product page: back-in-stock card ---------- */
  function enhancePanel(panel) {
    if (panel.__nmBound) return;
    panel.__nmBound = true;

    /* Submit without leaving the product page. */
    var f = panel.closest('form');
    if (!f) return;
    f.addEventListener('submit', function (e) {
      var get = function (n) { var i = f.querySelector('[name="' + n + '"]'); return i ? i.value : ''; };
      var fields = {
        email: get('contact[email]'), product: get('contact[Product]'), url: get('contact[Product URL]'),
        variant: get('contact[Variant]'), id: get('contact[Variant ID]')
      };
      if (!fields.email || !fields.id) return;
      e.preventDefault();
      var btn = f.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; }
      send(fields).then(function (ok) {
        if (!ok) { HTMLFormElement.prototype.submit.call(f); return; }
        var msg = el('div', 'nm-inline-success', T.done);
        panel.hidden = true;
        panel.parentNode.insertBefore(msg, panel.nextSibling);
        if (btn) btn.disabled = false;
        setTimeout(function () { msg.remove(); }, 8000);
      }).catch(function () {
        if (btn) btn.disabled = false;
        HTMLFormElement.prototype.submit.call(f);
      });
    });
  }

  function scan() {
    document.querySelectorAll('[data-restock-panel]').forEach(enhancePanel);
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();
